import { gql } from "@apollo/client";

/** Product listing **/
export const CHECKOUT = gql`
  mutation checkout(
    $layout: String
    $billing_type: String
    $firstName: String
    $lastName: String
    $email: String
    $company: String
    $job_title: String
    $date_of_birth: Date
    $mobile: String
    $fax: String
    $website: String
    $additional: String
    $address: ContactAddress
    $billing_address: ContactBillingAddress
    $coupon: String
    $planId: String
    $source: String
    $price: Float
    $taxesId: [Int]
    $cardNumber: String
    $month: String
    $year: String
    $cvv: String
    $cardType: String
    $nameOnCard: String
    $password: String
    $locale: String
    $visitor_id: String
    $referer: String
    $trackerData: String
    $accepted_recurring_terms: Boolean
    $accepted_recurring_terms_text_version: String
  ) {
    checkoutLayout(
      layout: $layout
      billing_type: $billing_type
      first_name: $firstName
      last_name: $lastName
      email: $email
      company: $company
      job_title: $job_title
      date_of_birth: $date_of_birth
      mobile: $mobile
      fax: $fax
      website: $website
      additional: $additional
      address: $address
      billing_address: $billing_address
      coupon: $coupon
      plan_id: $planId
      source: $source
      price: $price
      taxes_id: $taxesId
      card_name: $nameOnCard
      card_number: $cardNumber
      month: $month
      year: $year
      cvv: $cvv
      card_type: $cardType
      password: $password
      locale: $locale
      visitor_id: $visitor_id
      referer: $referer
      trackerData: $trackerData
      accepted_recurring_terms: $accepted_recurring_terms
      accepted_recurring_terms_text_version: $accepted_recurring_terms_text_version
    ) {
      status
      method
      requires_client_confirmation
      client_secret
      connected_account_id
      publishable_key
      redirect_url
      payment_attempt_id
      payment_intent_id
      message
      subscription_id
      token
    }
  }
`;

export const GET_PAYMENT_ATTEMPT_STATUS = gql`
  query getPaymentAttemptStatus($payment_attempt_id: Int!) {
    getPaymentAttemptStatus(payment_attempt_id: $payment_attempt_id) {
      status
      payment_status
      provider
      subscription_status
      action_required
      requires_action_url
      failure_code
      failure_message
      paid_at
    }
  }
`;
/** Coupon Apply And Validate **/
export const COUPON_APPLIED = gql`
  mutation checkCoupon(
    $layout: String
    $coupon: String
    $email: String
    $planId: Int
    $type: String
  ) {
    couponCheckCode(
      layout: $layout
      coupon: $coupon
      email: $email
      plan_id: $planId
      type: $type
    ) {
      discount_type
      amount
      applies_to
    }
  }
`;

/** GET RENEW SUBSCRIPTION DETAIL **/
export const RENEW_SUBSCRIPTION_DETAIL = gql`
  query getSubscriptionDetailsForRenew(
    $subscription_id: String
    $upgrade_to_plan: Int
  ) {
    subscriptionDetailForRenewSubscription(
      subscription_id: $subscription_id
      upgrade_to_plan: $upgrade_to_plan
    ) {
      subscription_id
      plan_id
      price
      billing_type
      plan_name
      fee_name
      fee_value
      fee_charge_on
      first_name
      last_name
      email
      phone
      job_title
      date_of_birth
      mobile
      fax
      website
      #address
      billing_address
      currency
      number_format
      sandbox_mode
      payment_gateway
      company_name
      company_logo
      is_white_label
      status
      plan_detail {
        name
        price
        billing_type
      }
    }
  }
`;

/** RENEW SUBSCRIPTION **/
export const RENEW_SUBSCRIPTION = gql`
  mutation checkoutLayoutRenewSubscription(
    $subscription_id: String
    $first_name: String
    $last_name: String
    $company: String
    $website: String
    $job_title: String
    $coupon: String
    $nameOnCard: String
    $card_number: String
    $month: String
    $year: String
    $cvv: String
    $card_type: String
    $billing_address: ContactBillingAddress
    $accepted_recurring_terms: Boolean
    $accepted_recurring_terms_text_version: String
  ) {
    checkoutLayoutRenewSubscription(
      subscription_id: $subscription_id
      first_name: $first_name
      last_name: $last_name
      company: $company
      website: $website
      job_title: $job_title
      billing_address: $billing_address
      coupon: $coupon
      card_name: $nameOnCard
      card_number: $card_number
      month: $month
      year: $year
      cvv: $cvv
      card_type: $card_type
      accepted_recurring_terms: $accepted_recurring_terms
      accepted_recurring_terms_text_version: $accepted_recurring_terms_text_version
    ) {
      status
      method
      requires_client_confirmation
      client_secret
      connected_account_id
      publishable_key
      payment_intent_id
      redirect_url
      payment_attempt_id
      message
    }
  }
`;

/** GET invoice detail for payment **/
export const TRANSACTION_DETAIL_PAYMENT = gql`
  query transactionDetailForPayment($transactionId: String) {
    transactionDetailForPayment(transaction_id: $transactionId) {
      id
      first_name
      last_name
      email
      address
      billing_address
      document_type
      name
      project_name
      offerings_text_form
      due_date
      status
      total
      paid_amount
      payment_requested
      currency
      #time_zone
      #language
      number_format
      sandbox_mode
      payment_gateway
      payment_mode
      transactionable_type
      payment_status
      company_name
      company_logo
      is_white_label
      cardDetails {
        id
        name
        card_number
        expiry_date
        default
        card_type
      }
    }
  }
`;

export const ACCEPT_TRANSACTION_PAYMENT = gql`
  mutation acceptTransactionPayment(
    $id: String
    $first_name: String
    $last_name: String
    $card_id: Int
    $card_name: String
    $card_number: String
    $month: String
    $year: String
    $cvv: String
    $card_type: String
    $billing_address: ContactBillingAddress
    $accepted_recurring_terms: Boolean
    $accepted_recurring_terms_text_version: String
  ) {
    acceptTransactionPayment(
      id: $id
      first_name: $first_name
      last_name: $last_name
      card_id: $card_id
      billing_address: $billing_address
      card_name: $card_name
      card_number: $card_number
      month: $month
      year: $year
      cvv: $cvv
      card_type: $card_type
      accepted_recurring_terms: $accepted_recurring_terms
      accepted_recurring_terms_text_version: $accepted_recurring_terms_text_version
    ) {
      status
      method
      requires_client_confirmation
      client_secret
      connected_account_id
      publishable_key
      payment_intent_id
      redirect_url
      payment_attempt_id
      message
    }
  }
`;

export const CAPTURE_PAYPAL_ORDER = gql`
  mutation capturePaypalOrder(
    $id: String
    $order_id: String
    $payment_attempt_id: Int
  ) {
    capturePaypalOrder(
      id: $id
      order_id: $order_id
      payment_attempt_id: $payment_attempt_id
    ) {
      status
      method
      payment_attempt_id
      message
    }
  }
`;

export const SUBSCRIPTION_INVOICE_DETAIL = gql`
  query getSubscriptionInvoiceDetail($transactionId: String) {
    getSubscriptionInvoiceDetail(transaction_id: $transactionId) {
      id
      first_name
      last_name
      email
      address
      billing_address
      document_type
      name
      project_name
      offerings_text_form
      due_date
      status
      total
      paid_amount
      payment_requested
      currency
      number_format
      sandbox_mode
      cardDetails {
        id
        name
        card_number
        expiry_date
        default
        card_type
      }
      transaction_document_items {
        id
        line_type
        line_type_id
        title
        line_price_type
        line_price
        quantity
        description
        tax_type
        tax_value
        itemable {
          ... on UserSubscription {
            id
            name
            price
            billing_period
          }
        }
        created_at
        updated_at
      }
    }
  }
`;

export const ACCEPT_SUBSCRIPTION_PAYMENT = gql`
  mutation acceptSubscriptionPayment(
    $id: String
    $first_name: String
    $last_name: String
    $billing_address: ContactBillingAddress
    $card_name: String
    $card_id: Int
    $card_number: String
    $month: String
    $year: String
    $cvv: String
    $card_type: String
    $accepted_recurring_terms: Boolean
    $accepted_recurring_terms_text_version: String
  ) {
    acceptSubscriptionPayment(
      id: $id
      first_name: $first_name
      last_name: $last_name
      billing_address: $billing_address
      card_name: $card_name
      card_id: $card_id
      card_number: $card_number
      month: $month
      year: $year
      cvv: $cvv
      card_type: $card_type
      accepted_recurring_terms: $accepted_recurring_terms
      accepted_recurring_terms_text_version: $accepted_recurring_terms_text_version
    ) {
      status
      method
      requires_client_confirmation
      client_secret
      connected_account_id
      publishable_key
      payment_intent_id
      redirect_url
      payment_attempt_id
      message
    }
  }
`;

export const RENEW_SUBSCRIPTION_PAYMENT = gql`
  mutation checkoutPaymentFailedSubscription(
    $subscription_id: String
    $first_name: String
    $last_name: String
    $phone: String
    $job_title: String
    $date_of_birth: Date
    $mobile: String
    $fax: String
    $website: String
    $company: String
    $additional: String
    $billing_address: ContactBillingAddress
    $card_name: String
    $card_number: String
    $month: String
    $year: String
    $cvv: String
    $card_type: String
    $accepted_recurring_terms: Boolean
    $accepted_recurring_terms_text_version: String
  ) {
    checkoutPaymentFailedSubscription(
      subscription_id: $subscription_id
      first_name: $first_name
      last_name: $last_name
      phone: $phone
      job_title: $job_title
      date_of_birth: $date_of_birth
      mobile: $mobile
      fax: $fax
      website: $website
      company: $company
      additional: $additional
      billing_address: $billing_address
      card_name: $card_name
      card_number: $card_number
      month: $month
      year: $year
      cvv: $cvv
      card_type: $card_type
      accepted_recurring_terms: $accepted_recurring_terms
      accepted_recurring_terms_text_version: $accepted_recurring_terms_text_version
    ) {
      status
      message
      method
      requires_client_confirmation
      client_secret
      connected_account_id
      publishable_key
      payment_intent_id
      redirect_url
      payment_attempt_id
    }
  }
`;
